import { Injectable } from '@angular/core';
import { Category } from '@spartacus/core';
import { Observable } from 'rxjs';
import { CategoryAdapter } from './category.adapter';

@Injectable()
export class CategoryConnector {
  constructor(protected adapter: CategoryAdapter) {}

  get(catalogId: string, catalogVersionId: string, categoryId: string): Observable<Category> {
    return this.adapter.load(catalogId, catalogVersionId, categoryId);
  }
}
